/*
 * @Description:
 * @Version: 1.0.3
 * @Autor: chen wei
 * @Date: 2020-05-12 11:50:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-07-29 15:38:46
 */
import Vue from 'vue'
import App from './app.vue'

Vue.config.productionTip = false
new Vue({
  render: h => h(App)
}).$mount('#app')
